import React, { PropsWithChildren } from 'react';
import { Typography } from '@vp/swan';

export default function ModalSubheader(props: PropsWithChildren) {
    return (
        <Typography fontSkin="title-item" marginBottom={'4'}>
            {props.children}
        </Typography>
    );
}
